// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QCHR2{width:100%}@media screen and (min-width:768px){.QCHR2{justify-content:space-between}}@media screen and (min-width:768px){.QCHR2,.ZyBqU{display:flex;align-items:center}}@media screen and (min-width:768px){.LGIv-{position:relative;flex-shrink:0}.oZfdq{position:absolute;z-index:2;top:-16px;right:40px;min-width:171px;padding:16px 16px 0;background-color:#fff;border-radius:4px;box-shadow:0 0 16px rgba(0,0,0,.08)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleHeaderAuthors": "QCHR2",
	"container": "ZyBqU",
	"more": "LGIv-",
	"tooltip": "oZfdq"
};
module.exports = ___CSS_LOADER_EXPORT___;
